// You can pass some outer data here
import _ from 'lodash';

export default function({ actionColumn = {} } = {}) {
  return [
    {
      prop: 'id',
      label: '编号',
      width: 80
    },
    {
      prop: 'en_name',
      label: '页面英文名'
    },
    {
      prop: 'name',
      label: '页面名'
    },
    {
      prop: 'created_at',
      label: '创建时间',
      renderCell: 'time'
    },
    {
      prop: 'updated_at',
      label: '更新时间',
      renderCell: 'time'
    },
    _.merge({
      prop: 'action',
      label: '操作',
      width: 100,
      detail: true,
      edit: true
    }, actionColumn)
  ];
}

export function createEditColumns({ html } = {}) {
  return [
    {
      prop: 'name',
      label: '页面名',
      form: {
        component: 'input'
      }
    },
    {
      prop: 'content',
      label: '内容',
      form: {
        component: 'editor',
        props: {
          html
        }
      }
    }
  ]
}
